import Echo from "laravel-echo";
import Pusher from "pusher-js";
import { reverbAuthUrl } from "@config/urls.config";

export function createReverbConnection(token: string, tenant: string) {
  const key = process.env.NEXT_PUBLIC_REVERB_APP_KEY;
  let host = process.env.NEXT_PUBLIC_REVERB_HOST;
  if (!host && process.env.NEXT_PUBLIC_API_BASE_URL) {
    try {
      host = new URL(process.env.NEXT_PUBLIC_API_BASE_URL).hostname;
    } catch {
      return null;
    }
  }
  if (!token || !tenant || !key || !host) return null;

  const scheme = process.env.NEXT_PUBLIC_REVERB_SCHEME || "https";
  const port = Number(process.env.NEXT_PUBLIC_REVERB_PORT || (scheme === "https" ? 443 : 80));

  return new Echo({
    broadcaster: "reverb",
    Pusher,
    key,
    wsHost: host,
    wsPort: port,
    wssPort: port,
    forceTLS: scheme === "https",
    enabledTransports: ["ws", "wss"],
    authEndpoint: reverbAuthUrl,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
        "X-Tenant": tenant,
      },
    },
  });

}
